const ncArgsNC = (contrato, tipoNota, observacNota, numeroNota, valorNota, fechaHoraHoy, numeroFra, idRangoFact,
    listFactDetN, valorNotaFact) => {
// console.log(listFactDetN)
  // let fechaHoy = new Date()
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

  let creaColecc = [], movColecc = []
// console.log(valorNota)
  let valorAntesImptos = 0, nuevoValorNota = valorNota
  listFactDetN.forEach((elemento1, ii) => {
    let nuevoValor = elemento1.nuevoValor
    if(nuevoValorNota<=elemento1.nuevoValor){
      nuevoValor = nuevoValorNota
      nuevoValorNota = 0
    }else{
      nuevoValorNota -= nuevoValor
    }

    let valor = 0, valorImpto = 0, porcImpto = 0
    // if(this.state.permiteNDF){
    // porcImpto = Math.round((elemento1.valorIF * 100) / elemento1.valorSF)
    porcImpto = elemento1.porcImpto
    valor = Math.round(nuevoValor / ((100 + porcImpto) / 100))
    valorImpto = nuevoValor - valor
    // console.log(porcImpto, valor, valorImpto)
    // }else{
    //   valor = elemento1.valor - nuevoValor
    // }
    valorAntesImptos += valor

    if(valor>0){
      let argsUpd = {
        "tipoAct": ii===0?"CrearDetNota1":"CrearDetNota2",
        "numeroFra": numeroFra,
        "codigoServicio": elemento1.codigoServicio,
        "nombreResumido": elemento1.nombreResumido,
        "descripcionServicio": elemento1.descripcionServicio,
        "descrClaseServ": elemento1.descrClaseServ,
        "concepto": elemento1.nombreResumido,
        "periodo": elemento1.periodo,
        "tipo": "SF",
        "consecEnFra": elemento1.consecEnFra,
        "valor": valor,
      }
      movColecc.push(argsUpd)
      // console.log(argsUpd)
      if(valorImpto>0){
        argsUpd = {
          "tipoAct": "CrearDetNota2",
          "numeroFra": numeroFra,
          "codigoServicio": elemento1.codigoServicio,
          "nombreResumido": elemento1.nombreResumido,
          "descripcionServicio": elemento1.descripcionServicio,
          "descrClaseServ": elemento1.descrClaseServ,
          "concepto": "Impuesto",
          "periodo": elemento1.periodo,
          "tipo": "IF",
          "consecEnFra": elemento1.consecEnFra,
          "porcImpto": elemento1.porcImpto,
          "valor": valorImpto,
        }
        movColecc.push(argsUpd)
        // console.log(argsUpd)
      }
    }else{
      // console.log(contrato, valor)
    }
  })

  let argsAdd = {}
  argsAdd['tipoNota'] = tipoNota
  argsAdd['numeroNota'] = numeroNota
  argsAdd['idRangoFact'] = idRangoFact
  argsAdd['numeroFra'] = numeroFra
  argsAdd['fechaNota'] = fechaHoy
  argsAdd['contrato'] = contrato
  argsAdd['valorAntesImptos'] = valorAntesImptos
  argsAdd['valorNota'] = valorNota
  argsAdd['observacNota'] = observacNota
  argsAdd['fechaCreate'] = fechaHoy + ' ' + horaHoy
  argsAdd['valorNotaFact'] = valorNotaFact
  creaColecc.push(argsAdd)
// console.log(movColecc)
  let colecc = {creaColecc, movColecc}

  return colecc
}

export default ncArgsNC
